import React from 'react';
import { LOYALTY, PROMOTION_DELIVERY_FREE } from '../../../constants';
import { useAppSelector } from '../../../redux/hook';
import MinCartPriceInfo from './MinCartPriceInfo';
import SkeletonRow from '../../Skeleton/SkeletonRow.view';

type OrderPromotionProps = {
  promotion: any;
  commande: any;
  promotionType: string;
  prefix: string;
  isLoading: boolean;
  freeDelivery?: boolean;
};

export default function OrderPromotion({
  promotion,
  commande,
  promotionType,
  prefix,
  isLoading,
  freeDelivery = false
}: OrderPromotionProps) {
  const { secondaryColor, name } = useAppSelector(
    (state) => state.configurationReducer
  );

  const isLoyalty = promotion?.promoCode === LOYALTY;
  const isFreeDelivery = promotion?.type === PROMOTION_DELIVERY_FREE;
  const getPromotionLabel = () => {
    if (isLoyalty) return `Fidélité ${name ?? ''}`;
    if (isFreeDelivery || freeDelivery) return 'Livraison offerte';
    return `Promotion ${promotion?.promoCode}`;
  };
  return (
    <div
      className={`row ${!commande && promotion?.minBasketPrice && 'strike-through-price'
        }`}
    >
      <SkeletonRow
        label={
          <div
            className={`col-8 no-localization`}
            style={{
              color: !commande && !promotion?.minBasketPrice && secondaryColor,
            }}
          >
            {getPromotionLabel()}
            {promotion?.minBasketPrice > 0 && !commande && (
              <MinCartPriceInfo
                promoType={isLoyalty ? 'loyalty' : 'code-promo'}
                minBasketPrice={promotion?.minBasketPrice}
              />
            )}
          </div>
        }
        amount={
          <div
            className='text-right'
            style={{
              color: !commande && !promotion?.minBasketPrice && secondaryColor,
            }}
          >
            {prefix}
            {promotionType}
          </div>
        }
        isLoading={isLoading}
      />
    </div>
  );
}
